import React from 'react'
import Button from 'components/Button'
import { TextAreaContainer } from 'components/inputs'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'
import { useBrandingSettings } from 'hooks/branding'
import ScopeChangeRequestRejectOnBehalfOfClientViewModel from './ScopeChangeRequqestRejectOnBehalfOfClientViewModel'
import { observer } from 'mobx-react'
import styles from './ScopeChangeRequestRejectOnBehalfOfClientDialog.sass'

interface ScopeChangeRequestRejectOnBehalfOfClientDialogProps {
  vm: ScopeChangeRequestRejectOnBehalfOfClientViewModel
}

export default observer(
  function ScopeChangeRequestRejectOnBehalfOfClientDialog({
    vm,
  }: ScopeChangeRequestRejectOnBehalfOfClientDialogProps) {
    const { corporateMode } = useBrandingSettings()

    return (
      <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
        <ModalSheetHeader>
          <div className={styles.closeButtonContainer}>
            <ModalSheetHeaderCloseButton dataTest="scope-change-request-close-reject-dialog" />
          </div>
        </ModalSheetHeader>
        <ModalSheetContent>
          <ModalSheetContentBlock>
            {!corporateMode && (
              <ModalSheetContentIllustration
                src={require('assets/images/img_missing-permissions.svg')}
                alt="Reject"
              />
            )}
            <ModalSheetContentTitle>
              Are you sure that you want to reject on behalf of the client?
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              You will need to provide a clear reason as to why the requested
              changes are rejected.
            </ModalSheetContentDescription>
            <div className={styles.reasonContainer}>
              <label className={styles.reasonLabel}>Reason</label>
              <TextAreaContainer
                rows={4}
                model={vm}
                field="reason"
                name="reason"
                maxLength={vm.MAX_REASON_LENGTH}
                error={vm.validation.getError('reason')}
                status={vm.validation.getError('reason') ? 'danger' : 'default'}
                placeholder="This will be visible to everyone"
                help={`${vm.reasonCharsRemaining} characters remaining`}
                data-test="scope-change-request-client-decline-reason"
              />
            </div>
          </ModalSheetContentBlock>
        </ModalSheetContent>
        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button onClick={vm.close} type="default">
              Close
            </Button>
            <Button
              onClick={vm.decline}
              type="danger"
              dataTest="scope-change-request-reject-client"
              loading={vm.decline.pending}
              disabled={vm.decline.pending}
            >
              Reject
            </Button>
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </ModalSheet>
    )
  },
)
